import { useState } from "react";
import { useNavigate } from "react-router-dom";

// @mui
import {
  Stack,
  Box,
  styled,
  Menu,
  MenuItem,
  ListItemIcon,
  Avatar,
  Divider,
} from "@mui/material";
// config
import { NAV } from "../../../config-global";
// utils
import { hideScrollbarX } from "../../../utils/cssStyles";
// components
import Logo from "../../../components/logo";
import { NavSectionMini } from "../../../components/nav-section";
//
import navConfig from "./config-navigation";
import NavToggleButton from "./NavToggleButton";
import { PRIMARY } from "../../../theme/palette";
import { CustomAvatar } from "../../../components/custom-avatar";
import { useAuthContext } from "../../../sections/auth";
import Iconify from "../../../components/iconify/Iconify";

// ----------------------------------------------------------------------

const StyledRoot = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  borderTop: "1px solid #fff",
  position: "fixed",
  bottom: "0",
  left: "0",
  width: "inherit",
  justifyContent: "flex-start",
  maxWidth: `${NAV.W_DASHBOARD_MINI}px`,
}));

export default function NavMini() {
  const { user, logout } = useAuthContext();
  const [anchorEl, setAnchorEl] = useState(null);

  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_DASHBOARD_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: "fixed",
          backgroundColor: PRIMARY.main,
          width: NAV.W_DASHBOARD_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScrollbarX,
        }}
      >
        <Logo sx={{ mx: "auto", my: 2, width: "50px" }} />

        <NavSectionMini data={navConfig} />
      </Stack>
    </Box>
  );
}
